import { render, staticRenderFns } from "./AdditionalFields.vue?vue&type=template&id=084d42e6&scoped=true&lang=pug&"
import script from "./AdditionalFields.vue?vue&type=script&lang=ts&"
export * from "./AdditionalFields.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalFields.vue?vue&type=style&index=0&id=084d42e6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084d42e6",
  null
  
)

export default component.exports